import React from "react"
import { Collapse, Fade, Grow, Slide, Zoom } from "@mui/material"

export default function Transition({ when, children, type = "grow" }) {
  switch (type) {
    case "collapse": return <Collapse in={when} appear={false} unmountOnExit>{children}</Collapse>
    case "fade": return <Fade in={when} appear={false} unmountOnExit>{children}</Fade>
    case "slide": return <Slide in={when} appear={false} unmountOnExit>{children}</Slide>
    case "zoom": return <Zoom in={when} appear={false} unmountOnExit>{children}</Zoom>
    case "grow": default: return <Grow in={when} appear={false} unmountOnExit>{children}</Grow>
  }
}